
// SVG Icon: play-story
export default { id: "terriajs-play-story" };
export const id = "terriajs-play-story";
export const name = "play-story";
